import { render } from "./OutsourcingProcess.vue?vue&type=template&id=2c7ec084"
import script from "./OutsourcingProcess.vue?vue&type=script&lang=js"
export * from "./OutsourcingProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__